import React from "react";
import { Carousel } from "react-bootstrap";
import person1 from "../../images/1.jpg";
import person2 from "../../images/2.jpg";
import "./Testimonials.css";

const Testimonials = ({ Reviewref }) => {
  return (
    <section className="Testimonials" ref={Reviewref}>
      <h1>Testimonials</h1>
      <Carousel indicators={true} controls={true} interval={5000}>
        <Carousel.Item>
          <div className="slide">
            <div className="content">
              <img src={person1} alt="Simab Dave" />
              <h6>
                Far far away, behind the word mountains, far from the countries
                Vokalia and Consonantia, there live the blind texts.
              </h6>
              <h5>Simab Dave - Web Designer</h5>
            </div>
          </div>
        </Carousel.Item>

        <Carousel.Item>
          <div className="slide">
            <div className="content">
              <img src={person2} alt="Johnthan Doe" />
              <h6>
                Far far away, behind the word mountains, far from the countries
                Vokalia and Consonantia, there live the blind texts.
              </h6>
              <h5>Johnthan Doe - UX Designer</h5>
            </div>
          </div>
        </Carousel.Item>
      </Carousel>
    </section>
  );
};

export default Testimonials;
